import React from 'react';
import { X } from 'lucide-react';
import { ab1, ab2, ab3, tm1, tm2, tm3, tm4 } from '../assets/assets';
import Header from '../components/Header';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const AboutUs = ({ onClose }) => {
  return (
    <>
    <Header/>
    <div className="font-['Poppins'] bg-gray-50">
      {/* Header - Different on mobile vs desktop */}
      <div className="flex justify-between items-center p-4 bg-white md:hidden">
  
        <button 
          onClick={onClose}
          className="text-gray-700 ml-auto"
          aria-label="Close"
        >
            <Link to={"/"}>
          <X size={20} />
          </Link>
        </button>
      </div>
      
      <div className="mx-auto  md:py-12">
        <h1 className="text-2xl md:text-4xl font-bold text-center mb-8 md:mb-16">About Us</h1>
        
        <div className="space-y-10 md:space-y-16">
          {/* Our Mission Section */}
          <section className="w-[95%] mx-auto md:flex md:items-center md:gap-12 md:flex-row-reverse">
            <div className="mb-4 md:mb-0 md:w-1/2">
              <img 
                src={ab1}
                alt="Team members collaborating"
                className="w-full h-48 md:h-auto object-cover md:rounded-md"
              />
            </div>
            <div className="md:w-1/2">
              <h2 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6">Our Mission</h2>
              <div className="text-sm md:text-base text-gray-700 space-y-4">
                <p className="leading-relaxed">
                  At Hellocer, our mission is clear and unwavering: 
                  to empower connections that enrich futures. 
                  We understand that behind every job application 
                  and every job posting lies a story of potential 
                  and aspiration. We're dedicated to bridging the 
                  gap between talent and opportunity, fostering 
                  meaningful connections that drive personal and 
                  professional growth. Our commitment extends 
                  beyond merely matching resumes with job 
                  descriptions.
                </p>
                <p className="leading-relaxed">
                  We believe in the transformative power of the right 
                  career move, both for individuals seeking new 
                  challenges and for companies looking to build 
                  exceptional teams. By providing a seamless and 
                  intuitive platform, we aim to simplify the hiring 
                  process, making it more efficient and rewarding 
                  for everyone involved.
                </p>
              </div>
            </div>
          </section>
          
          {/* Our Approach Section */}
          <section className="w-[95%] mx-auto md:flex md:items-center md:gap-12">
            <div className="mb-4 md:mb-0 md:w-1/2">
              <img 
                src={ab2}
                alt="Workspace with coffee and notebook"
                className="w-full h-48 md:h-auto object-cover md:rounded-md"
              />
            </div>
            <div className="md:w-1/2">
              <h2 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6">Our Approach</h2>
              <div className="text-sm md:text-base text-gray-700 space-y-4">
                <p className="leading-relaxed">
                  We're dedicated to redefining the hiring experience 
                  through our unique approach. We believe in finding the 
                  perfect match between talent and opportunity. That's why 
                  we leverage advanced data-driven insights to understand 
                  our users better, recognizing each individual's 
                  unique preferences, skills, and aspirations.
                </p>
                <p className="leading-relaxed">
                  We are committed to continuously improving and refining 
                  our platform to better serve the needs of our users. 
                  We actively seek feedback from our community and 
                  collaborate with industry experts to implement enhancements 
                  that enhance usability, accessibility, and overall user experience.
                </p>
                <p className="leading-relaxed">
                  By embracing innovation and embracing change, we aim 
                  to create a hiring ecosystem that is inclusive, transparent, 
                  and empowering for all. We strive to constantly improve the 
                  hiring experience and unlock new possibilities for 
                  talent and opportunity.
                </p>
              </div>
            </div>
          </section>
          
          {/* The Team Section */}
          <section className="w-[95%] mx-auto md:flex md:items-center md:gap-12 md:flex-row-reverse">
            <div className="mb-4 md:mb-0 md:w-1/2">
              <img 
                src={ab3}
                alt="Team members in meeting"
                className="w-full h-48 md:h-auto object-cover md:rounded-md"
              />
            </div>
            <div className="md:w-1/2">
              <h2 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6">The Team</h2>
              <div className="text-sm md:text-base text-gray-700 space-y-4">
                <p className="leading-relaxed">
                  Our leadership team sets the course for innovation 
                  and growth. With a wealth of experience and a 
                  forward-thinking mindset, they steer our company 
                  towards new horizons in the realm of recruitment. 
                  The team is made up of accomplished tech and 
                  hiring platform leaders.
                </p>
                <p className="leading-relaxed">
                  Our customer success team is dedicated to your 
                  satisfaction. They're your partners, guiding you 
                  through every step of the process and providing 
                  ongoing support to ensure your success in hiring.
                </p>
              </div>
            </div>
          </section>
          
          {/* Meet the Team Section */}
          <section className='bg-[#D9D9D9] w-full px-5 py-10'>
            <h2 className="text-xl md:text-2xl font-semibold text-center mb-4 md:mb-8">MEET THE TEAM</h2>
            <div className="grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-6">
              <div>
                <img 
                  src={tm1}
                  alt="Team member 1"
                  className="w-full aspect-square object-cover"
                />
              </div>
              <div>
                <img 
                  src={tm2}
                  alt="Team member 2"
                  className="w-full aspect-square object-cover"
                />
              </div>
              <div>
                <img 
                  src={tm3}
                  alt="Team member 3"
                  className="w-full aspect-square object-cover"
                />
              </div>
              <div>
                <img 
                  src={tm4}
                  alt="Team member 4"
                  className="w-full aspect-square object-cover"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
<Footer/>
    </>
  );
};

export default AboutUs;